import { Button, Group } from "@mantine/core";
import { useState } from "react";

interface AdvancePaymentsPlansControlsProps {
  isArchiveDisabled: boolean;
  isArchiveLoading: boolean;
  onArchive: () => void;
  onGenerate: (year: number) => Promise<void>;
}

function AdvancePaymentsPlansControls({
  isArchiveDisabled,
  isArchiveLoading,
  onArchive,
  onGenerate
}: AdvancePaymentsPlansControlsProps) {
  return (
    <Group gap="xs">
      <GenerateAdvancePaymentsPlansButton
        year={new Date().getFullYear()}
        onGenerateAdvancePaymentsPlans={onGenerate}
      />
      <GenerateAdvancePaymentsPlansButton
        year={new Date().getFullYear() + 1}
        onGenerateAdvancePaymentsPlans={onGenerate}
      />
      <Button
        color="primary"
        disabled={isArchiveDisabled}
        loading={isArchiveLoading}
        onClick={onArchive}
      >
        Archivieren
      </Button>
    </Group>
  );
}

interface GenerateAdvancePaymentsPlansButtonProps {
  year: number;
  onGenerateAdvancePaymentsPlans: (year: number) => Promise<void>;
}

function GenerateAdvancePaymentsPlansButton({
  year,
  onGenerateAdvancePaymentsPlans
}: GenerateAdvancePaymentsPlansButtonProps) {
  const [submitting, setSubmitting] = useState(false);

  function handleClick() {
    setSubmitting(true);
    onGenerateAdvancePaymentsPlans(year).finally(() => {
      setSubmitting(false);
    });
  }

  return (
    <Button color="primary" loading={submitting} onClick={handleClick}>
      Erstellen für {year}
    </Button>
  );
}

export { AdvancePaymentsPlansControls };
